module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/12DyOmt/tc-custom/9781633022287.jpg?1718106717099",
      "alt": "This image is the cover for the book THE OKLAHOMA PREPPER - Your Ultimate Survival Guide"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("THE OKLAHOMA PREPPER - Your Ultimate Survival Guide\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("The Oklahoma Prepper is meant to be a resource and a guidepost. The information in this book should assist you in preparing for surviving a major disaster such as worldwide economic collapse or war; anything which may occur. We must always be ready for any situation which may arise. Prepping is truly about the gear and the mentality. That includes the equipment to get home, to get out, and the mental fortitude to handle any situation life, or the world, may throw at us.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Matthew E. Sheets\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Matthew E. Sheets has been a prepper and a survivalist his entire life. He has not just studied the information contained in this book but lived it since his childhood. Matthew has studied and lives the survivalist lifestyle to truly understand what it will take to survive any disaster, and to help teach others how to stay safe and alive in a disastrous situation.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Total Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0